export enum CollectionAssetStatus {
	OFFCHAIN = "OFFCHAIN",
	PENDING = "PENDING",
	ONCHAIN = "ONCHAIN",
	PAUSED = "PAUSED",
}
